import { useState, useEffect } from "react";
import { Quote, ChevronLeft, ChevronRight, Star } from "lucide-react";
import { TESTIMONIALS } from "../data/siteData";

export const Testimonials = () => {
  const [i, setI] = useState(0);
  const total = TESTIMONIALS.length;

  useEffect(() => {
    const id = setInterval(() => setI((p) => (p + 1) % total), 7000);
    return () => clearInterval(id);
  }, [total]);

  const t = TESTIMONIALS[i];

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 md:py-32 bg-brand-forest text-brand-cream relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.06] grain pointer-events-none" />
      <div className="container-app relative">
        <div className="max-w-4xl">
          <p className="overline text-brand-gold mb-4">Real Stories</p>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-brand-cream tracking-tight">
            Florida families who trusted us with their hardest moments.
          </h2>
        </div>

        <div className="mt-16 max-w-4xl">
          <Quote className="h-12 w-12 text-brand-gold mb-6" />
          <blockquote
            key={i}
            data-testid="active-testimonial"
            className="font-accent text-2xl md:text-4xl leading-relaxed text-brand-cream animate-fade-up"
          >
            "{t.quote}"
          </blockquote>

          <div className="mt-10 flex items-center justify-between flex-wrap gap-6">
            <div>
              <div className="flex items-center gap-1 mb-2">
                {[...Array(5)].map((_, k) => (
                  <Star
                    key={k}
                    className="h-4 w-4 fill-brand-gold text-brand-gold"
                  />
                ))}
              </div>
              <p className="font-heading font-semibold text-lg text-brand-cream">
                {t.name}
              </p>
              <p className="text-sm text-brand-cream/60">{t.role}</p>
            </div>

            <div className="flex items-center gap-3">
              <button
                data-testid="testimonial-prev"
                aria-label="Previous testimonial"
                onClick={() => setI((p) => (p - 1 + total) % total)}
                className="grid h-11 w-11 place-items-center rounded-md border border-brand-cream/30 hover:bg-brand-cream/10 transition-colors"
              >
                <ChevronLeft className="h-5 w-5" />
              </button>
              <span className="text-sm text-brand-cream/70 tabular-nums">
                {String(i + 1).padStart(2, "0")} / {String(total).padStart(2, "0")}
              </span>
              <button
                data-testid="testimonial-next"
                aria-label="Next testimonial"
                onClick={() => setI((p) => (p + 1) % total)}
                className="grid h-11 w-11 place-items-center rounded-md border border-brand-cream/30 hover:bg-brand-cream/10 transition-colors"
              >
                <ChevronRight className="h-5 w-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
